import React from "react";
import {Separator} from "@radix-ui/react-select";
import {SidebarNav} from "@/components/ui/sidebar-nav.tsx";
import {SectionTitle} from "@/components/ui/headings";
import {useTranslation} from "react-i18next";

const sidebarNavItems = [
    {
        title: "general",
        href: "/settings"
    },
    {
        title: "faq",
        href: "/settings/faq"
    },
    {
        title: "jobs",
        href: "/settings/jobs"
    }
];

interface SettingsLayoutProps {
    children: React.ReactNode;
}

export default function SettingsLayout({ children }: SettingsLayoutProps) {
    const {t} = useTranslation();

    return (
        <>
            <div className="container space-y-6 pt-12">
                <div className="space-y-0.5">
                    <SectionTitle>{t("common.settings")}</SectionTitle>
                    <p className="text-muted-foreground">
                        {t("settings.manageSiteSettings")}
                    </p>
                </div>
                <Separator className="my-6" />
                <div className="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">
                    <aside className="-mx-4 lg:w-1/5">
                        <SidebarNav items={sidebarNavItems} />
                    </aside>
                    <div className="flex-1">{children}</div>
                </div>
            </div>
        </>
    );
}
